module.exports = require("static-eval");